import './listModal.scss';

import { CircularProgress } from 'material-ui';
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';

import { deletePlantDetails } from '../../../actions/dashboardAction';
import { hidePlantListModal } from '../../../actions/modalActions';
import { IFlaggedFormDetails, IPlantDetails } from '../../../interfaces';
import { sendReminder, getPlantDetails } from '../../../services/dashboardService';
import { Alert } from '../Alert';
import { Async } from '../Async';
import { ErrorPage } from '../ErrorPage';
import { Loader } from '../Loader';
import { getCurrentUserAccessLevel } from '../../../utils/generalUtils';

export interface IListModalProps {
    id: string;
    modalID?: string;
    modalTitle: string;
    listHeadings: string[];
    listItemComponent: React.ComponentClass<{
        index: number, plantId?: string | IFlaggedFormDetails,
        onClick(plantID): void, userId?: string, formType?: string;
        isCompleted: boolean;
    }>;
    ids?: string[];
    className?: string;
    style?: React.CSSProperties;
    listTitle?: string;
    promise?(plantId): any;
    initialPromise?: any;
    plantDetails?: IPlantDetails;
    formType?: string;
}

export interface IListModalState {
    showDetails: boolean;
    showProgressBar: boolean;
    plantID: string;
}

export class ListModalImpl extends React.PureComponent<IListModalProps, IListModalState> {
    constructor(props: IListModalProps) {
        super(props);
        this.state = { showDetails: false, plantID: null, showProgressBar: false };
    }

    static defaultProps: IListModalProps;

    handleSendReminder = () => {
        this.setState({
            showProgressBar: true
        });
        sendReminder(this.state.plantID, this.props.formType, this);
    }

    renderPlantDetails = () => {
        const { plantDetails } = this.props;
        if (!plantDetails) {
            return <Loader type="async" />;
        }
        if (!plantDetails.PlantId) {
            return <div style={{ fontSize: '20px', color: 'gray', padding: '20px 0px', textAlign: 'center' }}
            >
                No Details Found
                <div style={{ marginTop: '20px' }} >
                    <button onClick={() => {
                        this.setState({ showDetails: false });
                        deletePlantDetails();
                    }} className="back-button" >Back</button>
                </div>

            </div>;
        }
        return <div style={{ textAlign: 'center' }} className="plant-details" >
            {this.state.showProgressBar ? <div className="progress-bar" >
                <CircularProgress size={150} color="#A4BF43" thickness={5} />
            </div> : ''}
            <div className="details-row" >
                <div
                    className="details-label" >PlantId: </div>
                &nbsp;
                <div className="details-value" > {plantDetails.PlantId || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Plant Region:</div>
                &nbsp;
                <div className="details-value" > {plantDetails.Plant_Region || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Plant Name:</div>
                &nbsp;
                <div className="details-value" > {plantDetails.Plant_Name || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Street:</div>
                &nbsp;
                <div className="details-value" > {plantDetails.Street || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Address City:</div>
                &nbsp;
                <div className="details-value" > {plantDetails.City || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >State:
                    &nbsp;
                    </div>
                <div className="details-value" > {plantDetails.State || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Zip Code:</div>
                &nbsp;
                <div className="details-value" > {plantDetails.ZipCode || 'NA'}</div>
            </div>
            <div className="details-row" >
                <div
                    className="details-label" >Country: </div>
                &nbsp;
                <div className="details-value" > {plantDetails.Country || 'NA'}</div>
            </div>
            {this.props.listTitle === 'Incomplete Plants' ?
                <div className="modal-button-container" >
                    <button onClick={() => {
                        this.setState({ showDetails: false });
                        deletePlantDetails();
                    }} className="back-button" >Back</button>
                    <span style={{ padding: '0px 10px' }} />
                    {getCurrentUserAccessLevel() === 'L1' || getCurrentUserAccessLevel() === 'L2' ?
                        <button
                            onClick={this.handleSendReminder}
                            className="reminder-button"
                        >
                            Send Reminder
                        </button> : ''}
                </div> : ''}
        </div>;
    }

    showPlantDetails = () => {
        return <Async
            identifier="LitModal"
            promise={() => this.props.promise(this.state.plantID)}
            loader={<Loader type="async" />}
            error={<ErrorPage />}
            content={this.renderPlantDetails()}
        />;
    }

    handleOnListItemClick = async (plantID) => {
        if (plantID instanceof Object) {
            await getPlantDetails(plantID.PlantId);
            this.setState({ showDetails: true, plantID: plantID.PlantId });
            return;
        }
        this.setState({ showDetails: true, plantID });
    }

    showPlantList = () => {
        const { ids, listItemComponent, listTitle } = this.props;
        const ListItem = listItemComponent;
        return ids.length > 0 ? ids.map((plantID, index) => {
            return <ListItem
                index={index}
                key={index}
                plantId={plantID}
                onClick={() => this.handleOnListItemClick(plantID)}
                formType={this.props.formType}
                isCompleted={this.props.listTitle.toLowerCase() === 'complete plants'}
            />;
        }) : <div style={{ fontSize: '16px', color: 'gray', textAlign: 'center' }} >No {listTitle} found. </div>;
    }

    hideModal = () => {
        hidePlantListModal();
        deletePlantDetails();
        this.setState({
            showDetails: false
        });
    }

    renderContent = () => {
        const { listHeadings } = this.props;
        return <Modal.Body style={{ backgroundColor: 'black', border: '1px solid #757575' }} >
            <Alert id="incomplete-list-update" />
            {this.state.showDetails ? '' :
                <div className="heading-container" >{listHeadings.map((heading, index) => {
                    return heading === '#' ?
                        <div
                            key={index}
                            className="heading" style={{ width: '20%' }}
                        >
                            #
                        </div> :
                        <div
                            key={index}
                            className="heading"
                            style={{ width: `${80 / (listHeadings.length - 1)}%` }}
                        >
                            {this.props.formType === 'Complete' ? 'Form Type' : heading}
                        </div>;
                })}</div>
            }
            {this.state.showDetails ?
                this.showPlantDetails() :
                <div className="list-items">
                    <PerfectScrollbar>
                        {this.showPlantList()}
                    </PerfectScrollbar>
                </div>}
        </Modal.Body>;
    }

    renderModalBody = () => {
        if (this.props.initialPromise) {
            return <Async
                identifier="InitialPromiseListModal"
                promise={this.props.initialPromise}
                error={<ErrorPage />}
                loader={<Loader bgColor="black" type="async" />}
                content={this.renderContent()}
            />;
        }
        return this.renderContent();
    }

    renderListItems = () => {
        const { id, ids, style, listTitle, className, modalTitle, modalID,
            listItemComponent, listHeadings } = this.props;
        if (id !== modalID) {
            return '';
        }
        return <Modal
            show={true}
            className={`${className} list-modal`}
            style={style}
            onHide={this.hideModal}
            aria-labelledby="contained-modal-title"
        >
            <Modal.Header closeButton style={modalHeader} >
                <Modal.Title id="contained-modal-title" style={{ color: 'white' }} >
                    {this.state.showDetails ?
                        <div className="back-button" onClick={() => this.setState({ showDetails: false })} >
                            <i style={{
                                fontSize: '22px', paddingRight: '10px'
                            }} className="fa fa-arrow-circle-left" aria-hidden="true"></i>
                            {`Details Of Plant ${this.state.plantID}`}
                        </div> : listTitle}
                </Modal.Title>
            </Modal.Header>
            {this.renderModalBody()}
        </Modal>;
    }

    render() {
        return this.renderListItems();
    }

}

export function mapStateToProps(state) {
    return {
        modalID: state.modal.get('listModalID'),
        ids: state.modal.get('listData'),
        listTitle: state.modal.get('listTitle'),
        formType: state.modal.get('formType'),
        plantDetails: state.dashboard.get('plantDetails'),

    };
}

export const ListModal = connect<{}, {}, IListModalProps>(mapStateToProps)(ListModalImpl as any);

const modalHeader: React.CSSProperties = {
    backgroundColor: '#A4BF43',
    border: 'none',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ListModal/index.tsx